import { render, staticRenderFns } from "./dairyParlor.vue?vue&type=template&id=e2ccaa4a&scoped=true&"
import script from "./dairyParlor.vue?vue&type=script&lang=js&"
export * from "./dairyParlor.vue?vue&type=script&lang=js&"
import style0 from "./dairyParlor.vue?vue&type=style&index=0&id=e2ccaa4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ccaa4a",
  null
  
)

export default component.exports